﻿﻿export interface IBackupPlan {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
}
